import { Wrapper } from 'components/auditorium/auditorium.style'
import { AuditoriumTicketScan } from 'components/auditorium/ticketScan'
import { ModeSelection } from 'components/modeSelection/modeSelection'
import { useState } from 'react'
import { EventDetails } from 'types/Event'

import { Container, Title } from './ticketScan.style'

interface Props {
    event: EventDetails
}

export const CheckAuditorium = ({ event }: Props) => {
    const [auditoriumViewMode, setAuditoriumViewMode] = useState<'floor' | 'gallery'>('floor')

    const auditorium = event.location.auditorium
    const galleryExists = !!auditorium.gallery

    const isGallery = auditoriumViewMode === 'gallery'
    const currentAuditorium = isGallery ? auditorium.gallery : auditorium

    const rows = currentAuditorium?.rows ?? null
    const columns = currentAuditorium?.columns ?? null
    const seats = currentAuditorium?.seats ?? []

    return (
        <Container>
            <Title>Nézőtér telítettsége</Title>
            <Wrapper>
                {galleryExists && (
                    <ModeSelection
                        options={[
                            { value: 'floor', label: 'Földszint' },
                            { value: 'gallery', label: event.location.auditorium.gallery?.gallery_name || 'Karzat' },
                        ]}
                        selectedValue={auditoriumViewMode}
                        onChange={setAuditoriumViewMode}
                        buttonClassName="my-button"
                        selectedButtonClassName="selected"
                    />
                )}
            </Wrapper>
            <AuditoriumTicketScan
                key={auditoriumViewMode}
                rows={rows}
                columns={columns}
                seats={seats}
                tickets={event.tickets || []}
                eventId={event.event_id}
                currentSeatData={undefined}
                success={false}
                showColorCodes={true}
                isGallery={isGallery}
                galleryName={
                    isGallery && currentAuditorium && 'gallery_name' in currentAuditorium ? currentAuditorium.gallery_name : undefined
                }
            />
        </Container>
    )
}
